import { useMutation } from '@tanstack/react-query'
import { submitFeedback } from '../api/feedback'

export function useSubmitFeedback() {
  return useMutation({
    mutationFn: submitFeedback,
  })
}
